import { TagIF } from "../types";
import axios from "./axios"; // 반드시 직접 만든 axios를 import 해야 함

interface TagResponse {
    id: number;
    name: string;
}

export const newTag = async(id: number, name: string) : Promise<TagResponse> => {
    const response = await axios.post("/tags/addTags", {id, name});
    return response.data;
}

export const deleteTags = async(tgt_tags: TagIF[]) => {
    const response = await axios.delete("/tags/deleteTags", {data: tgt_tags});
    return response.data;
}